(function() {
    'use strict';

    const MIN_HEADINGS = 2;
    const SCROLL_TIMEOUT = 800;
    const OBSERVER_ROOT_MARGIN = '-40% 0px -50% 0px';
    const ID_PREFIX = 'toc-';

    function createTocLink(heading, onClickCallback) {
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        link.className = 'has-text-md-regular-font-size';
        link.addEventListener('click', function(e) {
            e.preventDefault();
            if (onClickCallback) {
                onClickCallback();
            }
            smoothScrollTo(heading);
        });
        return link;
    }

    function initTOC() {
        const tocContainer = document.querySelector('.post-toc-list');
        const tocSidebar = document.getElementById('toc-sidebar');
        const mainContent = document.querySelector('.post-main-content');
        const mobileTocWrapper = document.querySelector('.post-toc-mobile');
        const mobileTocList = document.querySelector('.post-toc-mobile-list');
        
        if (!tocContainer || !mainContent || !tocSidebar) {
            return;
        }

        if (tocContainer.querySelector('ul')) {
            return;
        }

        const h2Headings = mainContent.querySelectorAll('h2, h2.wp-block-heading');
        
        if (h2Headings.length < MIN_HEADINGS) {
            return;
        }

        const tocList = document.createElement('ul');
        const tocLinks = [];
        
        h2Headings.forEach(function(heading, index) {
            let headingId = heading.id;
            if (!headingId || headingId === '') {
                const slug = slugify(heading.textContent.trim());
                const baseName = slug || 'heading';
                headingId = ID_PREFIX + baseName + '-' + (index + 1);
                heading.id = headingId;
            }

            const listItem = document.createElement('li');
            const link = createTocLink(heading, null);
            
            listItem.appendChild(link);
            tocList.appendChild(listItem);
            tocLinks.push({ link: link, listItem: listItem, heading: heading });
        });

        tocContainer.appendChild(tocList);

        if (mobileTocList) {
            const frag = document.createDocumentFragment();
            h2Headings.forEach(function(heading) {
                const li = document.createElement('li');
                const a = createTocLink(heading, function() {
                    const toggle = document.getElementById('show_toc');
                    if (toggle) toggle.checked = false;
                });
                li.appendChild(a);
                frag.appendChild(li);
            });
            mobileTocList.innerHTML = '';
            mobileTocList.appendChild(frag);
            if (mobileTocWrapper) {
                mobileTocWrapper.classList.remove('js-toc-hidden');
            }
        }
        
        initScrollSpy(tocLinks);
        
        if (tocLinks.length > 0) {
            tocLinks[0].listItem.classList.add('active');
        }

        tocSidebar.classList.remove('js-toc-hidden');
    }

    function slugify(text) {
        return text
            .toLowerCase()
            .replace(/[áčďéěíľňóřšťúůýžÁČĎÉĚÍĽŇÓŘŠŤÚŮÝŽ]/g, function(match) {
                const map = {
                    'á': 'a', 'č': 'c', 'ď': 'd', 'é': 'e', 'ě': 'e',
                    'í': 'i', 'ľ': 'l', 'ň': 'n', 'ó': 'o', 'ř': 'r',
                    'š': 's', 'ť': 't', 'ú': 'u', 'ů': 'u', 'ý': 'y', 'ž': 'z',
                    'Á': 'a', 'Č': 'c', 'Ď': 'd', 'É': 'e', 'Ě': 'e',
                    'Í': 'i', 'Ľ': 'l', 'Ň': 'n', 'Ó': 'o', 'Ř': 'r',
                    'Š': 's', 'Ť': 't', 'Ú': 'u', 'Ů': 'u', 'Ý': 'y', 'Ž': 'z'
                };
                return map[match] || match;
            })
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');
    }

    function smoothScrollTo(element) {
        // Use pure CSS smooth scrolling with scroll-padding-top
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }

    function initScrollSpy(tocLinks) {
        let isUserClick = false;

        const setActiveLink = function(id) {
            tocLinks.forEach(function(item) {
                const isActive = item.heading.id === id;
                item.listItem.classList.toggle('active', isActive);
            });
        };

        const observer = new IntersectionObserver(
            function(entries) {
                if (isUserClick) return;
                
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        setActiveLink(entry.target.id);
                    }
                });
            },
            {
                rootMargin: OBSERVER_ROOT_MARGIN,
                threshold: 0
            }
        );

        tocLinks.forEach(function(item) {
            observer.observe(item.heading);
            
            item.link.addEventListener('click', function() {
                isUserClick = true;
                setActiveLink(item.heading.id);
                
                setTimeout(function() {
                    isUserClick = false;
                }, SCROLL_TIMEOUT);
            });
        });

        window.addEventListener('hashchange', function() {
            const hash = location.hash.slice(1);
            if (!hash) return;
            const current = document.getElementById(hash);
            if (current) {
                setActiveLink(current.id);
            }
        });
    }

    function scheduleInit() {
        if ('requestIdleCallback' in window) {
            requestIdleCallback(initTOC);
        } else {
            initTOC();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scheduleInit);
    } else {
        scheduleInit();
    }
})();
